module.exports = __webpack_public_path__ + "static/media/group-cover-2.53b62b9d.jpg";